import { useEffect, useState } from "react";
import styles from "./tenantoffer.module.css";
import { Helmet } from "react-helmet";
import Loader from "../../../components/Loader";
import { Background, Parallax } from 'react-parallax';
import { Link as Linkto, useHistory } from "react-router-dom";
import moment from 'moment';
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

const TenantOffer = ({ history, match }) => {
    const { str } = match.params;
    const redirect = useHistory();
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(true);
    const [propertyDetails, setPropertyDetails] = useState(null);
    const [offerDetails, setOfferDetails] = useState(null);

    useEffect(() => {
        const fetchTemplates = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/offer-data/" + str, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setLoading(false);

                setPropertyDetails(response.data.propertyData);
                setOfferDetails(response.data.data);
            }).catch((error) => {
                redirect.push('/rental-application-invalid');
            });
        }
        fetchTemplates();
    }, [getAccessTokenSilently]);

    return (<>
        {loading && <Loader />}
        <Helmet title="Offer" />
        <Parallax strength={300} className="RentalParallax">
            <Background className="custom-bg">
                <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
            </Background>
        </Parallax>

        <div className="WhiteBG">
            <div className={`${styles.RentalAppliArea}`}>

                <div className={`${styles.RentalAppliHead}`}>
                    <img src={(propertyDetails?.app_theme_options && propertyDetails?.app_theme_options?.image_url && propertyDetails?.app_theme_options?.image_url !== '') ? propertyDetails?.app_theme_options?.image_url : '/static/img/logo.svg'} alt="logo" style={{ width: '200px' }} />
                    <p className={`${styles.RentalAppliHeadTitle}`}>{propertyDetails?.name}</p>
                </div>

                <div className={`${styles.ApplicantSec}`}>
                    <p className={`${styles.ApplicantSecTitle}`}>Offer: {offerDetails?.title}</p>
                    <div className={`${styles.TemplateMainConSec}`}>
                        <div dangerouslySetInnerHTML={{ __html: offerDetails?.html }} />
                    </div>
                </div>

            </div>

            <div className={`${styles.FooterWrap}`}>
                <div className={`${styles.footerMain}`}>

                    <div className={`${styles.footerMainLeft}`}>
                        <Linkto to={'/'}><img src={(propertyDetails?.app_theme_options && propertyDetails?.app_theme_options?.image_url && propertyDetails?.app_theme_options?.image_url !== '') ? propertyDetails?.app_theme_options?.image_url : '/static/img/logo.svg'} alt="logo" /></Linkto>
                    </div>

                    <div className={`${styles.footerMainRight}`}>
                        <div>
                            <h3>CONTACT US</h3>
                            <ul>
                                <li><a href={`mailto: ${propertyDetails?.email}`}>{propertyDetails?.email}</a></li>
                                <li><a href={`tel: ${propertyDetails?.phone}`} >{propertyDetails?.phone}</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3>FIND US</h3>
                            <ul>
                                <li>{propertyDetails?.address} <br />{propertyDetails?.city}, {propertyDetails?.state} {propertyDetails?.zip}</li>
                            </ul>
                        </div>
                        <div>
                            <h3>LEGAL</h3>
                            <ul>
                                <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li>PropertyDek © {moment().format("YYYY")}.<br />All rights reserved.</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </>)
}

export default TenantOffer;